export const getAllReteachPlates = (state) => state.reteachPlateState.reteachPlates;

export const getReteachPlateLastViewMode = (state) => state.reteachPlateState.lastViewMode;
